import { useSessionCRUDActions } from '@mm/state/actions/SessionCRUDActions';
import CompanyModel from '@mm/state/model/CompanyModel';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import customersLogo from 'assets/logo-customers-blue.svg';
import css from './WhiteLabelLayout.module.css';

type Props = {
  className?: string;
  children?: any;
  companyId?: number;
};

const useCompanyLogo = (companyId?: number) => {
  const [logoSrc, setLogoSrc] = useState('');

  const sessionCrudActions = useSessionCRUDActions();

  useEffect(() => {
    async function getCompanyLogo() {
      try {
        const { logo }: Partial<CompanyModel> =
          await sessionCrudActions.retrieveSessionCompany(companyId);
        if (logo) setLogoSrc(logo.urls.large);
        else setLogoSrc(customersLogo);
      } catch (e) {
        setLogoSrc(customersLogo);
      }
    }

    getCompanyLogo();
  }, []);

  return {
    logoSrc,
  };
};

export const WhiteLabelLayout = ({ className, children, companyId }: Props) => {
  // Note: companyId will always be present on this type
  const { logoSrc } = useCompanyLogo(companyId!);

  return (
    <div className={classNames(className, css.wrapper)}>
      <div className={css.card}>
        <div className={css.logoContainer}>
          <img src={logoSrc} alt="Logo" className={css.logo} />
        </div>
        {children}
      </div>
    </div>
  );
};
